module.exports = __webpack_public_path__ + "static/media/13.8efa3886.jpg";